import React, { memo } from 'react';
import { DropdownMetaItemStyle, preventDropdownFromClosing } from "./helperComponents";
import { jsx as ___EmotionJSX } from "@emotion/core";

var areEqual = function areEqual(prev, next) {
  return prev.children === next.children && prev.isOpen === next.isOpen && prev.borderPosition === next.borderPosition;
};

var DropdownMetaItem = /*#__PURE__*/memo(function (_ref) {
  var children = _ref.children,
      shouldHaveNoBorder = _ref.shouldHaveNoBorder,
      borderPosition = _ref.borderPosition,
      isOpen = _ref.isOpen;
  return ___EmotionJSX(DropdownMetaItemStyle, {
    shouldHaveNoBorder: shouldHaveNoBorder,
    borderPosition: borderPosition,
    onMouseUpCapture: preventDropdownFromClosing // If the header and footer unmount when the dropdown menu closes,
    // it's not possible to put interactive elements inside because the
    // element unmounts before the click event finishes firing.
    ,
    display: isOpen ? 'block' : 'none',
    "aria-hidden": !isOpen
  }, children);
}, areEqual);
export default DropdownMetaItem;